import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map, tap } from 'rxjs/operators';
import { serverSettingsClientContext } from '@portal/api-endpoints';
import { BuilderInfoService } from '@portal/builder';
import { SettingsResponse } from './profile-settings.interface';

@Injectable({ providedIn: 'root' })
export class ProfileSettingsService {
  private readonly http = inject(HttpClient);
  private readonly builderInfoService = inject(BuilderInfoService);

  getSettings(): Observable<{ value: SettingsResponse; success: boolean }> {
    return this.http.get<{ value: SettingsResponse; success: boolean }>(serverSettingsClientContext.getCurrent).pipe(
      map(v => {
        if (!v.success || !v.value) {
          return {
            value: null,
            success: true,
          };
        }

        return v;
      }),
      catchError(() => of({ value: null, success: true })),
      tap(v => {
        this.builderInfoService.updateSettings(v.value);
      }),
    );
  }
}
